export default "__VITE_ASSET__DuoPrCsO__"